import {Component, Input, OnDestroy, OnInit, ViewChild, computed, inject} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {AllergyAddCardComponent} from './allergy-add-card/allergy-add-card.component';
import {AppMatAutocompleteComponent} from '@xmedical/ui';
import {CoreService} from 'src/app/core/services/core.service';
import {map} from 'rxjs/operators';
import {AllergiesRepositoryService, Allergy, UserSettings, Patient} from '@xmedical/core';
import {PatientAllergiesStore, PatientStore} from '../../../core/state';

@Component({
    selector: 'app-allergies-widget',
    templateUrl: './allergies-widget.component.html',
    styleUrl: './allergies-widget.component.scss',
    standalone: false
})
export class AllergiesWidgetComponent implements OnInit, OnDestroy {

  error = '';
  loading = false;
  settings: UserSettings;
  @Input() readonly = false;
  @ViewChild(AppMatAutocompleteComponent) autocomplete: AppMatAutocompleteComponent;
  private subscriptions: Subscription[] = [];

  private patientStore = inject(PatientStore);
  protected allergiesStore = inject(PatientAllergiesStore);

  readonly allergies = computed(() => this.allergiesStore.items());

  constructor(
    private matDialog: MatDialog,
    private allergyRepository: AllergiesRepositoryService,
    private coreService: CoreService
  ) {
  }

  get hasError(): boolean {
    return this.error.length > 0;
  }

  get hasAllergies(): boolean {
    return this.allergies().length > 0;
  }

  get patientId(): number {
    return this.patientStore.current()?.id ?? 0;
  }

  get patient(): Patient | null {
    return this.patientStore.current();
  }

  searchAllergies$ = (query: string): Observable<Allergy[]> => {
    return this.allergyRepository.query(query)
      .pipe(map(response => response));
  }

  ngOnInit(): void {
    this.settings = this.coreService.settings();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  onAddNewItem() {
    const dialogRef = this.matDialog.open(AllergyAddCardComponent, {
      panelClass: 'mat-confirmation-dialog-responsive'
    });
    this.subscriptions.push(dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.autocomplete.search(result.allergy);
      }
    }));
  }

  onItemSelected(allergy: Allergy) {
    this.error = '';
    this.subscriptions.push(this.allergiesStore.add(allergy).subscribe({
      error: () => {
        this.error = 'Could not add new allergy to this patient';
      }
    }));
    this.autocomplete.cancelSearch();
  }
}
